module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-disabled-hover-50.0b54b0da.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-disabled-hover-50.png
// module id = 3412
// module chunks = 11